import React, { createContext, useContext } from 'react';

const AppContext = createContext();

export const AppProvider = ({ contentPage, setContentPage, children }) => {

    // Shared functions
    const navigateToPage = (page) => {
        setContentPage(page);
    };

    // Shared data
    const sharedData = {
        companyName: 'Avis Logistics',
        contact: {
            address: ["H.No-1, L.No-4, Namda-Basti", "P.O - Golmuri, Jamshedpur", "Jharkhand, India - 831003"],
            phone: ['+91-9113323648', '+91-7737373552'],
            email: ['ho@avis-logistics.com', 'avislogistics@rediffmail.com']
        }
    };

    const value = {
        contentPage,
        navigateToPage,
        sharedData
    };

    return (
        <AppContext.Provider value={value}>
            {children}
        </AppContext.Provider>
    );
};

export const useApp = () => {
    const context = useContext(AppContext);
    if (!context) {
        throw new Error('useApp must be used within AppProvider');
    }
    return context;
};
